// Calling the project's HTTP Cloud Functions as the signed-in arbiter.
//
// These are onRequest functions, not callables, so this is a plain fetch with a
// Bearer token — the same shape js/ui/player-db-page.js uses for the rating
// report. It lives here because more than one screen now needs it: removing a
// player withdraws their registration (js/ui/players.js), and deleting a
// tournament tells everyone who entered (js/app.js).
//
// Never throws. Every caller is doing something the user already committed to,
// and a network failure is a thing to report, not an exception to unwind.

// Production, or the Functions emulator on localhost (see ./backend.js).
// Re-exported because several screens import it from here.
import { FUNCTIONS_BASE } from './backend.js';

export { FUNCTIONS_BASE };

/**
 * POST a JSON body to a function, authenticated as the current user.
 *
 * @returns {Promise<{ok: boolean, error?: string, status?: number}>} the parsed
 *   response body, merged with `ok`. On failure `error` is the endpoint's own
 *   code where there is one, otherwise 'not-signed-in' or 'network'.
 */
export async function callFunction(name, body) {
    if (!window.authApp || typeof window.authApp.getIdToken !== 'function') {
        return { ok: false, error: 'not-signed-in' };
    }

    try {
        const token = await window.authApp.getIdToken();
        if (!token) return { ok: false, error: 'not-signed-in' };

        const res = await fetch(`${FUNCTIONS_BASE}/${name}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
            body: JSON.stringify(body || {})
        });
        const data = await res.json().catch(() => ({}));
        return res.ok ? { ok: true, ...data } : { ok: false, status: res.status, ...data };
    } catch (e) {
        console.error(`${name} failed:`, e);
        return { ok: false, error: 'network' };
    }
}

/** The language to render an outgoing email in: whichever the app is showing. */
export function currentLang() {
    return (window.i18n && window.i18n.getLang && window.i18n.getLang()) || 'no';
}
